var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',{attrs:{"size":"small"},on:{"change":_vm.changeColor},model:{value:(_vm.mainColor),callback:function ($$v) {_vm.mainColor=$$v},expression:"mainColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }